import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=50c6ec29&scoped=true"
import script from "./distribution.vue?vue&type=script&lang=js"
export * from "./distribution.vue?vue&type=script&lang=js"
import style0 from "./distribution.vue?vue&type=style&index=0&id=50c6ec29&prod&lang=css"
import style1 from "./distribution.vue?vue&type=style&index=1&id=50c6ec29&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6ec29",
  null
  
)

export default component.exports